import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {withStyles, createStyleSheet} from 'material-ui/styles'
import Input from 'material-ui/Input/Input'
import Button from 'material-ui/Button'
import Paper from 'material-ui/Paper'
import axios from 'axios'
import {server} from './constants'

const styleSheet = createStyleSheet('TextInputs', theme => ({
    container: {
        flex: 1,
        flexDirection: 'column',
        marginTop: theme.spacing.unit * 3,
    },
    input: {
        margin: theme.spacing.unit,
    },
    button: {
        margin: theme.spacing.unit,
    },
    result: {
        marginTop: theme.spacing.unit * 3,

    }

}));

class OrdinalForm extends Component {
    state = {
        number: '',
        result: '' // 'Por exemplo o ordinal  de 101 é: Centesimo primeiro'
    };


    get_ordinal = (number) => {
        let self = this
        axios.get(server + 'ordinal/', {
            params: {
                number: number
            }
        })
            .then(function (response) {
                self.setState({number: '', result: response.data.ordinal})
                console.log(self.state)
            })
            .catch(function (error) {
                console.log(error)
            });
    };

    onSubmit = e => {
        e.preventDefault();
        this.get_ordinal(this.state.number);
    };

    onChange = e => {
        if ((e.target.value === '') || (!isNaN(e.target.value) && e.target.value.length < 55)) {
            this.setState({number: e.target.value})
        }
    };

    render() {
        const classes = this.props.classes;
        const {state} = this;

        return (
            <div id="content">
                <form onSubmit={this.onSubmit}>

                    <Input className={classes.input}
                           placeholder="Número"
                           value={state.number}
                           onChange={this.onChange}
                    />

                    <Button color="primary"
                            type="submit"
                            className={classes.button}>
                        Calcular
                    </Button>
                </form>
                <Paper className={classes.result}>
                    <h3> {this.state.result}</h3>
                </Paper>
            </div>

        )
    }

}

OrdinalForm.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styleSheet)(OrdinalForm);


// WEBPACK FOOTER //
// ./src/formOrdinal.jsx